import { ClientQueryStatusEnum } from '../../../types/client-query';
import { Worksheet } from '../../../types/worksheet';
import QueriesContainer from '../../worksheet-v2/addons/client-queries/QueriesContainer';
import { QueriesAddonProvider } from '../../worksheet-v2/addons/client-queries/useQueriesAddon';
import PreviewSection from '../PreviewSection';

type QueriesPreviewProps = {
    worksheet: Worksheet;
};

function QueriesPreview({ worksheet }: QueriesPreviewProps): JSX.Element {
    const total = worksheet.clientQueries.length;
    const remaining = total - worksheet.clientQueries.filter((c) => c.status !== ClientQueryStatusEnum.RESOLVED).length;

    const figure = total === 0 ? `(0)` : `(${remaining}/${total})`;

    return (
        <PreviewSection title={`Client Queries ${figure}`}>
            <div className="mt-2 px-4">
                <QueriesAddonProvider>
                    <QueriesContainer worksheet={worksheet} key={worksheet.id} showTitle={false} />
                </QueriesAddonProvider>
            </div>
        </PreviewSection>
    );
}

export default QueriesPreview;
